import { render, staticRenderFns } from "./vpn-blog-article.vue?vue&type=template&id=509c6489&scoped=true"
import script from "./vpn-blog-article.vue?vue&type=script&lang=js"
export * from "./vpn-blog-article.vue?vue&type=script&lang=js"
import style0 from "./vpn-blog-article.vue?vue&type=style&index=0&id=509c6489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c6489",
  null
  
)

export default component.exports